import { BasicTypeError, getErrorName } from './typeError'
import { RESOURCES, TYPES } from './types'

export class CodeError extends BasicTypeError {
  constructor(
    public readonly resource: RESOURCES,
    type: TYPES,
    originalError?: Error,
    message?: string
  ) {
    super(type, originalError, message)
    this.name = getErrorName(type, resource)
  }
}
